import {
  Text,
  TokenTextAppearance,
  TextTag,
  TokenTextColor,
  DesignTokenSizeEnum,
} from '@volkswagen-onehub/components-core';
import {
  CardWrapper,
  ImageWrapper,
  LinearGradient,
  PlayIconWrapper,
  TextWrapper,
  Description,
  StyledDesktopImage,
  StyledMobileImage,
  StyledCTA,
} from './CTACard.styles';

import playIcon from '@/assets/play-icon.svg';
import Box from '../Box/Box';

export interface CTACardProps {
  image: ImgProps;
  title: string;
  text: string;
  label?: string;
  isVideo?: boolean;
  linkCtaLabel?: string;
  onClick: () => void;
}

interface ImgProps {
  desktopUrl: string;
  mobileUrl?: string;
}

function CTACard(props: CTACardProps) {
  const { title, text, label, image, isVideo, onClick, linkCtaLabel } = props;

  return (
    <CardWrapper onClick={onClick}>
      <ImageWrapper>
        {image.desktopUrl && (
          <StyledDesktopImage
            src={image.desktopUrl}
            alt={title}
            objectFit="cover"
            showMobileImage={!!image.mobileUrl}
          />
        )}
        {image.mobileUrl && (
          <StyledMobileImage
            src={image.mobileUrl}
            alt={title}
            objectFit="cover"
          />
        )}
      </ImageWrapper>
      <LinearGradient />

      {isVideo && (
        <PlayIconWrapper>
          <img src={playIcon} alt="Play icon" />
        </PlayIconWrapper>
      )}

      <TextWrapper>
        <Text
          bold
          appearance={TokenTextAppearance.bigcopy200}
          color={TokenTextColor.inherit}
          tag={TextTag.p}
        >
          {title}
        </Text>

        <Description
          appearance={TokenTextAppearance.copy100}
          color={TokenTextColor.inherit}
          tag={TextTag.p}
          isVideo={isVideo}
        >
          {text}
        </Description>

        {label && (
          <Box
            as={Text}
            bold
            appearance={TokenTextAppearance.copy200}
            color={TokenTextColor.inherit}
            tag={TextTag.p}
            mt={DesignTokenSizeEnum.static250}
          >
            {label}
          </Box>
        )}
        {linkCtaLabel && (
          <StyledCTA
            appearance={TokenTextAppearance.copy100}
            color={TokenTextColor.inherit}
            tag={TextTag.p}
          >
            {linkCtaLabel}
          </StyledCTA>
        )}
      </TextWrapper>
    </CardWrapper>
  );
}
export default CTACard;
